'use client'

import React from 'react'

interface SkipLinksProps {
  onSkipToContent: () => void
  onSkipToNavigation: () => void
}

const SkipLinks: React.FC<SkipLinksProps> = ({ onSkipToContent, onSkipToNavigation }) => {
  return (
    <div className="sr-only">
      <button
        onClick={onSkipToContent}
        className="fixed top-4 left-4 z-50 bg-cyan-600 text-white px-4 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-cyan-400 focus:ring-offset-2"
      >
        Skip to main content
      </button>
      <button
        onClick={onSkipToNavigation}
        className="fixed top-4 left-32 z-50 bg-purple-600 text-white px-4 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-400 focus:ring-offset-2"
      >
        Skip to navigation
      </button>
    </div>
  )
}

export default SkipLinks